import React, {Component} from 'react';
import {observer, inject} from 'mobx-react';
import intl from 'react-intl-universal';
import Mousetrap from 'mousetrap';
import ReactGA from 'react-ga';

import Button from '../../components/Button/index';
import {getLogoSrc} from "../../utils/Utils";

@inject("appStore")
@observer
class Landing extends Component {

    exitModal = () => {
        console.log('this.props.appStore: ', this.props.appStore.introModal);
        this.props.appStore.setIntroModal(false);
        this.props.navigate("/");
    };

    componentDidMount = () => {
        Mousetrap.bind(['escape'], this.exitModal);
        this.props.appStore.tracking.pageview('Landing');
    };
    componentWillUnmount = () => {
        Mousetrap.unbind(['escape'], this.exitModal);
        this.props.appStore.tracking.click('Close Landing');
    };
    createMarkup = (string) => {
        return {__html: string};
    };
    getHeadingContent = () => {
        return( <div className={'logo'}>
            {this.props.appStore.appConfig.content.introduction.headline}
        </div>);
    };

    getHeading = ()=>{
        if(this.props.appStore.isMobile){
            return (  <h3>
                {this.getHeadingContent()}
            </h3>);

        }else{
            return (  <h1>
                {this.getHeadingContent()}
            </h1>);
        }

    }


    render() {
        const appStoreColor = this.props.appStore.appConfig.content.brand.brandColor;
        let textColor = this.props.appStore.appConfig.content.brand.textColor;
        if (!textColor) {
            textColor = {
                r: 0,
                g: 0,
                b: 0,
                a: 1
            }
        }
        const style = {
            backgroundColor: `rgba(${appStoreColor.r}, ${appStoreColor.g}, ${appStoreColor.b}, ${appStoreColor.a})`,
            color: `rgba(${textColor.r}, ${textColor.g}, ${textColor.b}, ${textColor.a})`,
        };



        return (
            <div className={(this.props.appStore.isMobile) ? "Landing mobile" : "Landing desktop"}>
                <div className="content">
                    <div className={"container"} style={style}>
                        <Button onClick={this.exitModal} aria-label="Close button" className="closeButton"><i
                            className="fa fa-times" aria-hidden="true"/></Button>
                        {this.props.appStore.appConfig.content.introduction.displayLogo &&
                        this.props.appStore.appConfig.content.brand.logo &&
                        <div className="logo">
                            <img alt="Logo" src={getLogoSrc(this.props.appStore.appConfig.content.brand.logo)}/>
                        </div>}
                        {this.getHeading()}
                        <p dangerouslySetInnerHTML={this.createMarkup(this.props.appStore.appConfig.content.introduction.text)}/>
                        <div
                            className="extra-text">{this.props.appStore.appConfig.content.introduction.extra_text}</div>
                        <Button onClick={this.exitModal}
                                className="startButton">{this.props.appStore.introModal ? intl.get('Landing.start_answering') : intl.get('Landing.back_to_map')}</Button>
                        <div className="extra-info">
                            <div className="data">
                                <h3>{intl.get('Landing.data.header')}</h3>
                                <p dangerouslySetInnerHTML={this.createMarkup(this.props.appStore.appConfig.content.introduction.dataUsage)}/>
                            </div>
                            <div className="help">
                                <h3>{intl.get('Landing.help.header')}</h3>
                                <p dangerouslySetInnerHTML={this.createMarkup(this.props.appStore.appConfig.content.introduction.instructions)}/>
                            </div>
                        </div>
                        <ReactGA.OutboundLink
                            className="feedback-link"
                            eventLabel="Info modal feedback link"
                            to="http://www.surveygizmo.com/s3/4053943/Strategies-Tool-Feedback?tool=CoMap"
                            rel="noopener noreferrer"
                            target="_blank">
                            {intl.get('Landing.feedback')}
                        </ReactGA.OutboundLink>
                    </div>
                </div>
            </div>
        );
    }
}

export default Landing;



// WEBPACK FOOTER //
// ./src/scenes/Landing/index.js